import { Enum } from 'enumify-mod';

class AccountOptions extends Enum {
	static NEW_CUSTOMER;
	static RETURNING_CUSTOMER;
}

AccountOptions.initEnum({
	NEW_CUSTOMER: 'New Customer',
	RETURNING_CUSTOMER: 'Returning Customer'
});

/**
 * @return {SelectOption[]}
 */
AccountOptions.toOptions = () => [
	{ value: AccountOptions.NEW_CUSTOMER.value, label: 'I’m new customer', selected: false },
	{ value: AccountOptions.RETURNING_CUSTOMER.value, label: 'I already have Footshop account', selected: false }
];

export default AccountOptions;


// WEBPACK FOOTER //
// ./enums/AccountOptions.js